import { Component, Input, OnInit, Output } from "@angular/core";
import { Router,NavigationStart  } from "@angular/router";
import { ToasterService } from "../../../../common/services/toaster.service";
import { ModalController } from "@ionic/angular";
import { error } from "console";
import { WebOrderApprovals } from "../../models/web-order-approvals.model";

@Component({
  selector: "app-web-order-view.page",
  templateUrl: "web-order-view.page.html",
  styleUrls: ["./web-order-view.page.scss"],
})
export class WebOrderViewModalComponent implements OnInit {

order: WebOrderApprovals;

  constructor(private router: Router,
     private modalController: ModalController
  ) {
     const nav = this.router.getCurrentNavigation();
    this.order = nav?.extras?.state?.['order'];

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const nav = this.router.getCurrentNavigation();
        if (nav?.extras?.state?.['order']) {
          this.order = nav.extras.state['order'];
        }
      }
    });
  }
  
  ngOnInit(): void {
    if (!this.order) {
      this.router.navigate(['/admin-page/wo-approval']); 
    }
  }
  
  closeModal() {
    this.modalController.dismiss();
  }

  changePrinterView(): void {
      setTimeout(() => {
        print();
      }, 1000); 
    }
}
